<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!serviceActivitySelected) {
        <h1 class="title">Crear {{ termKey.ActivityServiceSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (serviceActivitySelected) {
        <h1 class="title">Editar {{ termKey.ActivityServiceSingular | term }}</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="serviceActivityForm" (ngSubmit)="saveServiceActivityForm()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (serviceActivityForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (serviceActivityForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 150 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Mes</mat-label>
              <input type="number" matInput placeholder="Mes" formControlName="month" />
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="lineSelected"
                [initialValue]="getLineValue()"
                placeholder="Seleccione una línea"
                label="Línea"
                noResults="Sin resultados"
                (onSelectOption)="onLinesSelected($event)"
              >
              </app-search-select>
            </div>

            <div class="search-select-container">
              <app-search-select
                [dataList]="addressSelected"
                [initialValue]="getAddressValue()"
                placeholder="Seleccione una dirección"
                label="Dirección"
                noResults="Sin resultados"
                (onSelectOption)="onAddressSelected($event)"
              >
              </app-search-select>
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Ubicación:</mat-label>

              <mat-select formControlName="locations" multiple>
                <input
                  class="searchInput"
                  matInput
                  [formControl]="searchControl"
                  placeholder="Buscar ubicación"
                  oninput="this.value = this.value.toUpperCase()"
                />
                @for (
                  location of listLocation | searchfilter: searchControl.value;
                  track location.id
                ) {
                  <mat-option [value]="location.id">
                    {{ location.city }} - {{ location.department }}
                  </mat-option>
                }
              </mat-select>
              @if (serviceActivityForm.get('locations')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>
          </div>
          @if (fromList) {
            <div class="form-grid">
              <div class="search-select-container">
                <app-search-select
                  [dataList]="assistanceServiceSelected"
                  [initialValue]="getassistanceServiceValue()"
                  placeholder="Seleccione un valor"
                  label="{{ termKey.AccompanimentServiceSingular | term }}"
                  noResults="Sin resultados"
                  (onSelectOption)="onAssistenceServiceSelected($event)"
                >
                </app-search-select>
              </div>
            </div>
          }
        </div>
        <button type="submit" class="primary-button" [disabled]="!serviceActivityForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
